import React from 'react';
import PropTypes from 'prop-types';
import './IconButton.css';

const IconButton = ({ iconClass, onClick, className, tooltip }) => {
  return (
    <div className="icon-button-container">
      <button className={`icon-button ${className}`} onClick={onClick}>
        <i className={iconClass}></i>
      </button>
      {tooltip && <span className="tooltip">{tooltip}</span>}
    </div>
  );
};

IconButton.propTypes = {
  iconClass: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string,
  tooltip: PropTypes.string, // New tooltip prop
};

export default IconButton;
